import WhIllegalArgumentException from "./WhIllegalArgumentException";

class WhArgumentLte0Exception extends WhIllegalArgumentException {
    constructor(message) {
        super();
        this.message = message;
    }
}

export default WhArgumentLte0Exception


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhArgumentLte0Exception.js